import { HttpResponse } from '@angular/common/http';

import { ApiOptions } from '../../api-options.decorator';
import { DefaultParams } from '../../default-params.model';
import { ParamsAdapter } from '../../params.adapter';
import { RoleCapacity } from '../../role-capacity';

import { ApiBaseMidBack } from './base';
import { Contract } from './types/contract';
import { IndexViewModel } from './types/indexViewModel';

/**
 * @internal
 */
export class ApiMidbackContract extends ApiBaseMidBack {
  @ApiOptions({ channel: 'deliveryPoint.get' })
  getAccountInDeliveryPoints(params: ParamsAdapter) {
    return this.get<Contract[]>('/contract/in-delivery-point-with-perimeters', params);
  }

  @ApiOptions({ channel: 'contractWithIndexGet' })
  getContractWithIndexes(params: ParamsAdapter) {
    return this.get<Contract[]>(`/contract/contract-with-indexes`, params);
  }

  @ApiOptions({ interceptErrors: false, responseType: 'blob', responseObserve: 'response' })
  getCustomSheetValuesExcel(params: ParamsAdapter) {
    return this.get<HttpResponse<Blob>>(`/contract/custom-sheet-value/export/excel`, params);
  }

  @ApiOptions({ interceptErrors: false, requestType: 'form' })
  importCustomSheetExcel(body: ParamsAdapter) {
    return this.put(`/contract/custom-sheet-value/import/excel`, body);
  }

  @ApiOptions({ interceptErrors: false, capacities: [RoleCapacity.apiReferentialRead] })
  getContractIndexes() {
    return this.get<IndexViewModel[]>(`/index/index`, new DefaultParams({ visibleInGeFront: true }));
  }
}
